<template>
  <div class="chart-box">
    <div class="null-data" v-show="!source || source.length == 0 || !notEmpty" >暂无数据 </div>
    <div class="charts"  ref="chart" :style="{width: '100%', height:height}"></div>

  </div>

</template>
<script>
  import Vue from 'vue'
  let echarts = require("echarts/lib/echarts");
  // 引入柱状图，折线图，饼图图标组件
  require("echarts/lib/chart/bar");
  require("echarts/lib/chart/line");
  require("echarts/lib/chart/pie");
  require("echarts/lib/chart/custom");
  // 引入提示框和title组件
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/title");
  require("echarts/lib/component/legend");
  require("echarts/lib/component/toolbox");
  require("echarts/extension/bmap/bmap.js");
  Vue.prototype.$echarts = echarts;
export default {
  props: {
    idName: {
      type: String,
      default: 'char'
    },
    option: {
      type: Object,
      default: null
    },
    titleText: {
      type: String,
      default: '标题'
    },
    height: {
        type: [Number, String],
        default: '300px'
    },
    source: { // 异步图表数据
      type: Array,
      default() {
        return []
      }
    },
    series: {
      type: Array,
      default() {
        return []
      }
    },
    noMerge: {
      type: Boolean,
      default: false
    },
    checkDeep: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    source: {
      deep: true,
      handler: function (souceData) {
        // 深层检查 source data
        if (this.checkDeep) {
          this.notEmpty = this.notEmptyData(souceData);
        }

        this.$nextTick(() => {
          this.setOptionEcharts(souceData)
        })
      }
    },
  },
  data() {
    return {
      myChart: null,
      timer: null,
      notEmpty: true
    }
  },
  mounted() {
    window.addEventListener('resize',this.resizeChart)
    this.$nextTick(() => {
      this.myChart = this.$echarts.init(this.$refs.chart);
      this.initChart()
    })
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    window.removeEventListener('resize', this.resizeChart)
  },

  methods: {
    initChart() {
      let initOption = {
        grid: {
          top: 60,
          left: 40,
          right: 40
        },
        color: ['rgb(24, 144, 255)','rgb(47, 194, 91)', 'rgb(250, 204, 20)', 'rgb(34, 50, 115)'],
        title: {
          left: 'center',
          top: 10,
          text: this.titleText,
          textStyle: {
            fontSize: 16,
            color: '#495060'
          }
        },
        series: [{
          type: 'line'
        }],
        yAxis: {},
        xAxis: {type: 'category'},
        legend: {
          temWidth: 10, // 设置宽度
          itemHeight: 10, // 设置高度
          icon: "rect",
          // itemHeight: 4,
          left: 'center',
          bottom: 0
        },
        tooltip: {},

      }
      let series = this.series.length > 0 ? { series : this.series} : {}
      let option = Object.assign({}, initOption, this.option, series)
      this.myChart.setOption(option);
    },
    setOptionEcharts(souceData) {
      try {
         this.myChart.showLoading()
        let series = this.series.length > 0 ? { series : this.series} : {}
        let option = Object.assign({},{
          title: {
            left: 'center',
            top: 10,
            text: this.titleText,
            textStyle: {
              fontSize: 16,
              color: '#495060'
            }
          },
          xAxis: {type: 'category'},
          yAxis: {},
          dataset: {
            source: this.source
          }
        }, series, this.option);
        this.myChart.setOption(option,this.noMerge);
        setTimeout(() => {
          this.myChart && this.myChart.hideLoading()
        },500)
      }catch(err) {
        console.log(err)
        this.myChart && this.myChart.hideLoading()
      }
    },
    resizeChart() {
      if (this.myChart) {
        clearTimeout(this.timer)
        this.timer=setTimeout(() =>{
          this.myChart.resize()
        },200);
      }
    },
    notEmptyData(dataList) {
      if (!dataList || !Array.isArray(dataList)) return false;

      // 如果第一行的 products 为空
      if (dataList[0].length <= 1) return false;

      // 检查 dataset 中数据是否全部为空
      return dataList.slice(1).some(
        data => !!data.find(
          (item, index) => index > 0 ? !!item : false
        )
      );
    }
  }
}

</script>

<style scoped>
  .chart-box{
    position: relative;
    /*height: 100%;*/
  }
  .null-data{
      width: 100%;
      height: 100%;
      background: #FFF;
      position: absolute;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #999;
  }

</style>
